// PayCancelPage — user cancelled Stripe Checkout. Route back to the event
// detail so they can try again or pick a different payment method.
import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

function eventDetailPath(kind, id) {
  if (kind === 'tournament')  return `/tournaments/${id}`;
  if (kind === 'round_robin') return `/round-robins/${id}`;
  if (kind === 'club_event')  return `/club-events/${id}`;
  return '/events';
}

export default function PayCancelPage() {
  const [sp] = useSearchParams();
  const navigate = useNavigate();
  useEffect(() => {
    const kind = sp.get('event_kind');
    const id = sp.get('event_id');
    const path = eventDetailPath(kind, id);
    toast.message('Payment cancelled. You can try again anytime.');
    navigate(path, { replace: true });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="max-w-md mx-auto py-10 px-4 text-center text-sm text-[#6a766e]" data-testid="pay-cancel">
      Returning to the event…
    </div>
  );
}
